export const getIsPair = (filterField) => {
    if (filterField) {
        switch (filterField) {
            case 'BANKROUTING_TSID':
            case 'BANK_ROUTING_BANK_ACCOUNT_HASH':
            case 'LEGAL_ID_STATE_LEGAL_ID_HASH':
            case 'BANKROUTING_AFFILIATE_KEY':
            case 'STATE_TSID_IPQS':
            case 'STATE_TSID_FULL':
            case 'AFFILIATE_KEY_SUB_CODE':
            case 'REFERRING_SITE_URL_TSID':
            case 'REFERRING_SITE_URL_AFFILIATE_KEY':
            case 'TRAFFIC_SOURCE_ID_SUB_CODE':
                return true
            default:
                return false
        }
    }
};

export const signatureBlockFilterFields = ['PRIMARYEMAIL',
                                            'BANKROUTING',
                                            'BANKROUTING_TSID',
                                            'BANKROUTING_AFFILIATE_KEY',
                                            'BANK_ROUTING_BANK_ACCOUNT_HASH',
                                            'LEGAL_ID_STATE_LEGAL_ID_HASH',
                                            'TRAFFIC_SOURCE_ID_SUB_CODE',
                                            'HOMESTATE',
                                            'STATE_TSID_IPQS',
                                            'STATE_TSID_FULL',
                                            'HOMEPHONE',
                                            'WORKPHONE',
                                            'MOBILEPHONE',
                                            'SSN_HASH',
                                            'REFERRING_SITE_URL',
                                            'REFERRING_SITE_URL_TSID',
                                            'REFERRING_SITE_URL_AFFILIATE_KEY',
                                            'AFFILIATE_KEY_SUB_CODE',
                                            'CLIENTIP',
                                            'MOMU_FRAUD',
                                            'NAME']

export const getFieldLabelsForCategory = (category) => {
    const fields = {
        first: '',
        second: ''
    }
    switch (category) {
        case 'BANKROUTING_TSID':
            fields.first = 'Bank Routing'
            fields.second = 'Traffic Source Id'
            break;
        case 'BANK_ROUTING_BANK_ACCOUNT_HASH':
            fields.first = 'Bank Routing'
            fields.second = 'Bank Account (Do not hash)'
            break;
        case 'LEGAL_ID_STATE_LEGAL_ID_HASH':
            fields.first = 'Legal Id Issuing State'
            fields.second = 'Legal Id Number (Do not hash)'
            break;
        case 'BANKROUTING_AFFILIATE_KEY':
            fields.first = 'Bank Routing'
            fields.second = 'Affiliate Key'
            break;
        case 'PRIMARYEMAIL':
            fields.first = 'Email'
            break;
        case 'BANKROUTING':
            fields.first = 'Bank Routing'
            break;
        case 'HOMESTATE':
            fields.first = 'Home State (Abbreviation)'
            break;
        case 'STATE_TSID_IPQS':
            fields.first = 'State'
            fields.second = 'Traffic Source Id'
            break;
        case 'STATE_TSID_FULL':
            fields.first = 'State'
            fields.second = 'Traffic Source Id'
            break;
        case 'TRAFFIC_SOURCE_ID_SUB_CODE':
            fields.first = 'Traffic Source Id'
            fields.second = 'Source Sub Code 1'
            break;
        case 'AFFILIATE_KEY_SUB_CODE':
            fields.first = 'Affiliate Key'
            fields.second = 'Source Sub Code 1'
            break;
        case 'HOMEPHONE':
            fields.first = 'Home Phone'
            break;
        case 'MOBILEPHONE':
            fields.first = 'Mobile Phone'
            break;
        case 'WORKPHONE':
            fields.first = 'Work Phone'
            break;
        case 'SSN_HASH':
            fields.first = 'Ssn Hash'
            break;
        case 'MOMU_FRAUD':
            fields.first = 'Traffic Source Id'
            break;
        case 'NAME':
            fields.first = 'Value'
            break;
        case 'REFERRING_SITE_URL':
            fields.first = 'Referring Site url';
            break;
        case 'CLIENTIP':
            fields.first = 'Client IP';
            break;
        case 'REFERRING_SITE_URL_TSID':
            fields.first = 'Referring Site url';
            fields.second = 'Traffic Source Id';
            break;
        case 'REFERRING_SITE_URL_AFFILIATE_KEY':
            fields.first = 'Referring Site url';
            fields.second = 'Affiliate Key';
            break;
        default:
            fields.first = 'Block Value'
            break;
    }

    return fields
};

